import { CSSObject } from '@emotion/react';
import { useTheme } from '../../../theme';
import { skeletonClasses } from '@mui/material/Skeleton';

export const useSkeletonStyles = (): Record<'container', CSSObject> => {
  const theme = useTheme();
  return {
    container: {
      backgroundColor: theme.avatar.fallback,
      [`&.${skeletonClasses.wave}::after`]: {
        background: `linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.35), transparent)`,
      },
    },
  };
};
